module.exports = __webpack_public_path__ + "img/logo-grey.4bd2ce70.png";